<template>
  <vs-card class="card-button" v-if="report.reportName">
    <div slot="header">
      <h5>{{ report.reportName }}</h5>
    </div>
    <div class="card-content">
      <ReportField
        v-for="(field, index) in report.fields"
        :key="index"
        :field="field"
        :reportType="report.reportType"
        :options="getFieldOptions(field)"
        :isDisabled="isFieldDisabledForField(field)"
        :loadingOptions="loadingOptions"
        @field-change="onFieldChange"
      />
    </div>
    <div class="download-button">
      <vs-button
        :disabled="isDownloadDisabled"
        size="small"
        color="dark"
        type="border"
        @click="downloadReport"
      >
        <font-awesome-icon :icon="['fas', 'arrow-down']"/>
      </vs-button>
    </div>
  </vs-card>
</template>

<script>
import ReportField from './ReportField.vue'

export default {
  name: 'ReportCard',
  components: {
    ReportField,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
    reportOptions: {
      type: Array,
      default: () => [],
    },
    dynamicBinderOptions: {
      type: Object,
      default: () => ({}),
    },
    loadingOptions: {
      type: Boolean,
      default: false,
    },
    isDownloadDisabled: {
      type: Boolean,
      default: true,
    },
    getOptions: {
      type: Function,
      required: true,
    },
    isFieldDisabled: {
      type: Function,
      required: true,
    },
  },
  methods: {
    getFieldOptions(field) {
      return this.getOptions(this.report.reportType, field);
    },
    
    isFieldDisabledForField(field) {
      return this.isFieldDisabled(this.report, field);
    },
    
    onFieldChange(field, selectedOption) {
      this.$emit('field-change', this.report, field, selectedOption);
    },
    
    downloadReport() {
      this.$emit('download', this.report);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/custom/components/_variables';

.card-button {
  margin: 0;

  .vs-card {
    &--header {
      padding: 1rem;
    }

    &--content {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      padding: 0 1rem 1rem;
      margin: 0;

      .card-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        @media (max-width: 640px) {
          justify-content: space-between;
          align-items: flex-end;
          flex-direction: column;
        }
      }

      .download-button {
        margin-left: 15px;

        @media (max-width: 640px) {
          display: flex;
        }

        button {
          padding: 9px;
          border: 1px solid #D5DAE0;
          background-color: $yellow !important;

          .vs-button-text {
            font-size: 10px;
            width: 12px;
            color: #35495e;
          }
        }
      }
    }
  }
}
</style>
